module.exports = __webpack_public_path__ + "static/media/Secretaria-de-Obras-01.3757bc66.jpg";